import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation, Trans } from "react-i18next";
import Orb from "./Orb";

const AboutIntro = () => {
  const { t } = useTranslation();
  return (
    <section className="about-us-banner text-center">
      <Container className="">
        <Orb color="rgb(139, 210, 211)" top="0vh" left="-40vh" />
        <Orb color="rgb(243, 143, 143)" top="0vh" right="-40vh" />

        <img src="/assets/logo.svg" alt="Childreams Logo" className="mb-4 logo" />
        <p className="lead section-title">
          <Trans
            i18nKey="about-desc"
            components={{
              green: <span className="color-green" />,
            }}
          />
        </p>
      </Container>
    </section>
  );
};

export default AboutIntro;
